<template>
  <button class="vkid-btn" @click="login">
    <span class="vkid-icon">VK</span>
    <span class="vkid-text">{{this.title}}</span>
  </button>
</template>

<script>
import { getSubdomain } from "@/utils/domain"
import axios from "axios";

export default {
  name: "VkAuthButton",

  props: {
    title: String,
    flow: {
      type: String,
      default: 'auth'
    }
  },

  methods: {
    getCookie(name) {
      const matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
          name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") +
          "=([^;]*)"
        )
      );
      return matches ? decodeURIComponent(matches[1]) : null;
    },
    async login() {
      try {
        const subdomain = getSubdomain()
        const quiz_token = this.getCookie("quiz_token")
        const res = await axios.post(
          "/api/auth/vk/start",
          {
            redirect_after_login: window.location.pathname,
            subdomain: subdomain,
            flow: this.flow,
            quiz_token: quiz_token
          },
          {
            withCredentials: true
          }
        )

        const { auth_url } = res.data

        if (!auth_url) {
          throw new Error("VK auth_url not returned")
        }

        // OAuth = redirect, а не XHR
        window.location.href = auth_url

      } catch (error) {
        console.error("VK auth start error", error)
        this.$toast?.error("Ошибка входа через VK")
      }
    }
  }
}
</script>

<style scoped>
.vkid-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background-color: #0077ff;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.vkid-btn:hover {
  background-color: #0066dd;
}

.vkid-btn:active {
  transform: scale(0.98);
}

.vkid-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background-color: #ffffff;
  color: #0077ff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
}

.vkid-text {
  white-space: nowrap;
}
</style>